import moment from '@/plugins/moment';
import { toCamelCaseProperties } from '@/utils/fn';
import { TreatmentFilter } from './';

export default class Area {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.active = !!args.active;
        this.areaId = args.areaId || 0;
        this.areaName = args.areaName || '';
        this.areaPolygonPoints = args.areaPolygonPoints;
        this.branchType = args.branchType || 0;
        this.createdByUserId = args.createdByUserId || '00000000-0000-0000-0000-000000000000';
        this.createdTime = moment(args.createdTime || '');
        this.description = args.description || '';
        this.imageUrl = args.imageUrl || '';
        this.imgAltDesciption = args.imgAltDesciption || '';
        this.latitude = parseFloat(args.latitude || 0);
		this.longitude = parseFloat(args.longitude || 0);
        this.linkName = args.linkName || '';
        this.linkUrl = args.linkUrl || '';
        this.metaDescription = args.metaDescription || '';
        this.metaKeywords = args.metaKeywords || '';
        this.radius = args.radius || 0;
        this.updatedByUserId = args.updatedByUserId || '00000000-0000-0000-0000-000000000000';
        this.updatedTime = moment(args.updatedTime || '');
	}
}

export class AreaAndTreatment {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.id = args.id || 0;
		this.title = args.title || '';
        this.description = args.description || '';
        this.latitude = args.latitude || 0;
        this.longitude = args.longitude || 0;
		this.url = args.url || '';
		this.image = args.image;
		this.imageUrls = args.imageUrls || [];
        this.treatments = (args.treatments || []).map(treatment => new TreatmentFilter(treatment));
        this.children = (args.children || []).map(district => new AreaDistrict(district));
	}
}

export class AreaDistrict {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.id = args.id || 0;
		this.title = args.title || '';
        this.description = args.description || '';
        this.latitude = args.latitude || 0;
        this.longitude = args.longitude || 0;
		this.url = args.url || '';
		this.image = args.image;
		this.imageUrls = args.imageUrls || [];
        this.treatments = (args.treatments || []).map(treatment => new TreatmentFilter(treatment));
        this.children = args.children || [];
	}
}
